// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KNrRO","colBig":"styles_colBig__3tad2","colSmall":"styles_colSmall__3Iwx3"};